import lozad from 'lozad';

export default {
  init() {
    // JavaScript to be fired on all pages

    const observer = lozad();
    observer.observe();

    /**
    ** Header Menu
    **/

    $(document).ready(function(){
      var menu = $(".main-menu");
      var hamburger = $(".hamburger");
      var line = $(".line");
      var menuOpen;

      function openMenu(){
        menu.css("left", "0px");
        line.css("background", "#004648");
        menuOpen = true;
      }

      function closeMenu(){
        menu.css("left", "-320px");
        line.css("background", "#004648");
        menuOpen = false;
      }

      function toggleMenu(){
        if (menuOpen) {
          closeMenu();
        } else {
          openMenu();
        }
      }

      hamburger.on({
        click: function(){
          toggleMenu();
        },
      })
    });

    /**
    ** End of Header Menu
    **/

    $('#primary-menu').smartmenus({ });

    $('.clients-slider').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      prevArrow: false,
      nextArrow: false,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 610,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('.slides').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    prevArrow: false,
    nextArrow: false,
    autoplay: true,
    autoplaySpeed: 4000,
  });

  function blogHeadingAlign() {
    $(".blog-feed .blog-feed-item .blog-item-heading").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".blog-feed .blog-feed-item .blog-item-heading").map(function () {
      return $(this).height();
    }));
    $(".blog-feed .blog-feed-item .blog-item-heading").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  function blogArchiveHeadingAlign() {
    $(".blog article .blog-body h3").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".blog article .blog-body h3").map(function () {
      return $(this).height();
    }));
    $(".blog article .blog-body h3").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  function categoryArchiveHeadingAlign() {
    $(".category article .blog-body h3").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".category article .blog-body h3").map(function () {
      return $(this).height();
    }));
    $(".category article .blog-body h3").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  function blogTagAlign() {
    $(".blog article .blog-body .blog-tags").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".blog article .blog-body .blog-tags").map(function () {
      return $(this).height();
    }));
    $(".blog article .blog-body .blog-tags").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  function categoryTagAlign() {
    $(".category article .blog-body .blog-tags").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".category article .blog-body .blog-tags").map(function () {
      return $(this).height();
    }));
    $(".category article .blog-body .blog-tags").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  function blogItemsAlign() {
    $(".blog article .blog-body").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".blog article .blog-body").map(function () {
      return $(this).height();
    }));
    $(".blog article .blog-body").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  function categoryItemsAlign() {
    $(".category article .blog-body").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".category article .blog-body").map(function () {
      return $(this).height();
    }));
    $(".category article .blog-body").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  function blogBodyContentAlign() {
    $(".blog article .blog-body .blog-content").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".blog article .blog-body .blog-content").map(function () {
      return $(this).height();
    }));
    $(".blog article .blog-body .blog-content").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  function categoryBodyContentAlign() {
    $(".category article .blog-body .blog-content").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".category article .blog-body .blog-content").map(function () {
      return $(this).height();
    }));
    $(".category article .blog-body .blog-content").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  function servicesHeadingAlign() {
    $(".services-container .services .inner .works-title").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".services-container .services .inner .works-title").map(function () {
      return $(this).height();
    }));
    $(".services-container .services .inner .works-title").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  function servicesContentAlign() {
    $(".services-container .services .inner .works-content").height('auto');
    var maxExcerpt = Math.max.apply(Math, $(".services-container .services .inner .works-content").map(function () {
      return $(this).height();
    }));
    $(".services-container .services .inner .works-content").each(function () {
      $(this).height(maxExcerpt);
    });
  }

  $(window).load(function(){
    var testimonialsimgHeight = $(".testimonials-feed-bg").height();
    // var mailTopimgHeight = $(".join-newsletter-bg").height();
    // var mailBottomimgHeight = $(".join-newsletter-bg-bottom").height();
    var heroHeight = $(".header-img-bg-pattern").height();

    $(".testimonials-feed").css("padding-bottom", testimonialsimgHeight);
    $(".join-newsletter-container").css("margin-top", -testimonialsimgHeight);

    $(".hero-section").css("margin-bottom", (-heroHeight/5)*4);

    blogHeadingAlign();
    servicesHeadingAlign();
    servicesContentAlign();
    blogArchiveHeadingAlign();
    blogItemsAlign();
    blogTagAlign();
    blogBodyContentAlign();
    categoryTagAlign();
    categoryItemsAlign();
    categoryBodyContentAlign();
    categoryArchiveHeadingAlign();
  });

  $(window).resize(function(){
    var testimonialsimgHeight = $(".testimonials-feed-bg").height();
    var mailTopimgHeight = $(".join-newsletter-bg").height();
    var mailBottomimgHeight = $(".join-newsletter-bg-bottom").height();
    var heroHeight = $(".header-img-bg-pattern").height();

    $(".testimonials-feed").css("padding-bottom", testimonialsimgHeight);
    $(".join-newsletter-container").css("margin-top", -testimonialsimgHeight);

    $(".selected-products, .wrap").css("padding-bottom", mailTopimgHeight);
    $(".testimonials-feed-container").css("margin-top", -mailTopimgHeight);

    $(".join-newsletter-container").css("margin-bottom", -mailBottomimgHeight);
    $(".find-us-content").css("margin-top", mailBottomimgHeight);

    $(".hero-section").css("margin-bottom", (-heroHeight/5)*4);

    blogHeadingAlign();
    servicesHeadingAlign();
    servicesContentAlign();
    blogArchiveHeadingAlign();
    blogItemsAlign();
    blogTagAlign();
    blogBodyContentAlign();
    categoryTagAlign();
    categoryItemsAlign();
    categoryBodyContentAlign();
    categoryArchiveHeadingAlign();
  });

  $(window).load(function(){
  });

},
finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js